import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getEnquiryHotelVenueList_action, getEnquiryHotelVenueDetails_action, insertUpdateOtherHotel_action, insertUpdateEnquiryHotelVenue_action, deleteEnquiryHotelVenue_action, } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/travelAndHospitality_action'
import { HotelDescriptionTypeActionId, toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Footer from "../../../../../common_components/Footer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Item } from "@hilla/react-components/Item.js";
import { Description } from "@mui/icons-material";
import { fill_action } from '../../../../../actions/fillCombo_action';



class TravelAndHospitalityMasterAU extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            HotelName: '',
            HotelNameErr: '',
            HotelAddress: '',
            HotelAddressErr: '',
            SingleOccupancyInINR: '',
            SingleOccupancyInINRErr: '',
            DoubleOccupancyInINR: '',
            DoubleOccupancyInINRErr: '',
            SingleOccupancyInUSD: '',
            SingleOccupancyInUSDErr: '',
            DoubleOccupancyInUSD: '',
            DoubleOccupancyInUSDErr: '',
            deleteID: '',
            deleteType: '',
            isAdd: false,
            EnquiryHotelVenueID: null,
            OtherHotelID: null,
            hotelDescriptionList: [],
            HotelDescriptionTypeList: [],
            PersonName: '',
            PersonNameErr: '',
            MobileNo: '',
            MobileNoErr: '',
            EmailId: '',
            EmailIdErr: '',
            Website: '',
            WebsiteErr: '',
            HotelType: null,
        }
    }

    componentDidMount() {
        this.getFillList(HotelDescriptionTypeActionId, '', '', '', '', '');
        this.setState({
            HotelType: this.props.location.state.HotelType || null,
            isAdd: this.props.location.state.isAdd || false,
            EnquiryHotelVenueID: this.props.location.state.EnquiryHotelVenueID || null,
            OtherHotelID: this.props.location.state.OtherHotelID || null,
        }, () => {
            if (!this.state.isAdd) {
                this.getEnquiryHotelVenueDetails()
            }
        })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    if (actionID === HotelDescriptionTypeActionId) {
                        this.setState({
                            HotelDescriptionTypeList: data.data
                        })
                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getEnquiryHotelVenueDetails() {
        const { HotelType } = this.state
        this.setState({ isLoading: true })
        this.props.getEnquiryHotelVenueDetails_action(this.state.EnquiryHotelVenueID, this.state.OtherHotelID)
            .then((data) => {
                if (data.error != 1) {
                    if (HotelType == 'EnquiryHotelVenue') {
                        this.setState({
                            isLoading: false,
                            HotelName: data.data[0]?.[0]?.HotelName || '',
                            HotelAddress: data.data[0]?.[0]?.HotelAddress || '',
                            SingleOccupancyInINR: data.data[0]?.[0]?.SingleOccupancyInINR || '',
                            DoubleOccupancyInINR: data.data[0]?.[0]?.DoubleOccupancyInINR || '',
                            SingleOccupancyInUSD: data.data[0]?.[0]?.SingleOccupancyInUSD || '',
                            DoubleOccupancyInUSD: data.data[0]?.[0]?.DoubleOccupancyInUSD || '',
                            hotelDescriptionList: data.data[1] || []
                        })
                    } else {
                        this.setState({
                            isLoading: false,
                            HotelName: data.data[0]?.[0]?.HotelName || '',
                            HotelAddress: data.data[0]?.[0]?.HotelAddress || '',
                            PersonName: data.data[0]?.[0]?.PersonName || '',
                            MobileNo: data.data[0]?.[0]?.MobileNo || '',
                            EmailId: data.data[0]?.[0]?.EmailId || '',
                            Website: data.data[0]?.[0]?.Website || '',
                        })
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    addDescriptionRow() {
        const { hotelDescriptionList } = this.state
        this.setState({
            hotelDescriptionList: [...hotelDescriptionList, {
                HotelDescriptionTypeID: null,
                Description: null,
            }]
        })
    }

    deleteDescriptionRow(index) {
        const { hotelDescriptionList } = this.state
        const row = hotelDescriptionList[index]
        this.setState({ hotelDescriptionList: hotelDescriptionList.filter((_, i) => i !== index) })
    }

    handleDescriptionChange(index, field, value) {
        const { hotelDescriptionList } = this.state
        const updated = hotelDescriptionList.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        )
        this.setState({ hotelDescriptionList: updated })
    }

    saveEnquiryHotelVenue() {
        const { EnquiryHotelVenueID, HotelName, HotelNameErr, HotelAddress, HotelAddressErr, SingleOccupancyInINR, SingleOccupancyInINRErr, DoubleOccupancyInINR, DoubleOccupancyInINRErr, hotelDescriptionList, SingleOccupancyInUSD, DoubleOccupancyInUSD } = this.state

        for (let i = 0; i < hotelDescriptionList.length; i++) {
            const row = hotelDescriptionList[i]
            if (!row.HotelDescriptionTypeID) { toastError(`Row ${i + 1}: Please select a Hotel Description Type`); return }
            if (!row.Description) { toastError(`Row ${i + 1}: Please enter Description`); return }
        }
        const entry = hotelDescriptionList.map(row => ({
            HotelDescriptionTypeID: row.HotelDescriptionTypeID || null,
            Description: row.Description || null,
        }))
        this.setState({ isLoading: true })
        this.props.insertUpdateEnquiryHotelVenue_action(EnquiryHotelVenueID, HotelName, HotelAddress, SingleOccupancyInINR, DoubleOccupancyInINR, SingleOccupancyInUSD, DoubleOccupancyInUSD, entry)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Enquiry Hotel Venue saved successfully")
                    this.setState({ isLoading: false })
                    setTimeout(() => {
                        this.props.navigate('/travelAndHospitalityMasterList')
                    }, 1000);
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    saveOtherHotel() {
        const { OtherHotelID, HotelName, HotelNameErr, HotelAddress, HotelAddressErr, PersonName, MobileNo, MobileNoErr, EmailId, EmailIdErr, Website, WebsiteErr, } = this.state

        this.setState({ isLoading: true })
        this.props.insertUpdateOtherHotel_action(OtherHotelID, HotelName, HotelAddress, PersonName, MobileNo, EmailId, Website)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Other Hotel Details saved successfully")
                    this.setState({ isLoading: false })
                    setTimeout(() => {
                        this.props.navigate('/travelAndHospitalityMasterList')
                    }, 1000);
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    render() {
        const { isLoading, isOpen, HotelName, HotelNameErr, HotelAddress, HotelAddressErr, SingleOccupancyInINR, SingleOccupancyInINRErr, DoubleOccupancyInINR, DoubleOccupancyInINRErr, hotelDescriptionList, HotelDescriptionTypeList, DoubleOccupancyInUSD, DoubleOccupancyInUSDErr, SingleOccupancyInUSD, SingleOccupancyInUSDErr, HotelType, PersonName, PersonNameErr, MobileNo, MobileNoErr, EmailId, EmailIdErr, Website, WebsiteErr } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">Security Services Master</h6>
                                </div>
                            </div>
                            <div className="admin-top-space p-2 px-0">
                                {HotelType == 'EnquiryHotelVenue' ?
                                    <>
                                        <div className="row m-0">
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Hotel Name<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={HotelName}
                                                    onChange={(e) => this.setState({ HotelName: e.target.value, HotelNameErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{HotelNameErr}</span>}
                                            </div>
                                            <div className="col-xl-8">
                                                <label htmlFor="validationCustom03">
                                                    Hotel Address<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={HotelAddress}
                                                    onChange={(e) => this.setState({ HotelAddress: e.target.value, HotelAddressErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{HotelAddressErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Single Occupancy (INR)<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={SingleOccupancyInINR}
                                                    onChange={(e) => this.setState({ SingleOccupancyInINR: e.target.value, SingleOccupancyInINRErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{SingleOccupancyInINRErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Double Occupancy (INR)<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={DoubleOccupancyInINR}
                                                    onChange={(e) => this.setState({ DoubleOccupancyInINR: e.target.value, DoubleOccupancyInINRErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{DoubleOccupancyInINRErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Single Occupancy (USD)<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={SingleOccupancyInUSD}
                                                    onChange={(e) => this.setState({ SingleOccupancyInUSD: e.target.value, SingleOccupancyInUSDErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{SingleOccupancyInUSDErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Double Occupancy (USD)<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={DoubleOccupancyInUSD}
                                                    onChange={(e) => this.setState({ DoubleOccupancyInUSD: e.target.value, DoubleOccupancyInUSDErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{DoubleOccupancyInUSDErr}</span>}
                                            </div>
                                        </div>
                                        <div className="row m-0 mt-2">
                                            <div className="table-responsive">
                                                <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center" style={{ width: '50px' }}>Sr No.</th>
                                                            <th className="text-center" style={{ width: '300px' }}>Description Type</th>
                                                            <th className="text-center">Description</th>
                                                            <th className="text-center" style={{ width: '60px' }}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {hotelDescriptionList.length > 0 ? hotelDescriptionList.map((row, index) => (
                                                            <tr key={index}>
                                                                <td className="text-center">{index + 1}</td>
                                                                <td className="text-center">
                                                                    <select className="form-control"
                                                                        value={row.HotelDescriptionTypeID}
                                                                        onChange={(e) => this.handleDescriptionChange(index, 'HotelDescriptionTypeID', e.target.value)} >
                                                                        <option value={null}>Select</option>
                                                                        {
                                                                            HotelDescriptionTypeList.length > 0 && HotelDescriptionTypeList.map(data => (
                                                                                <option value={data.HotelDescriptionTypeID} key={data.HotelDescriptionTypeID}>{data.Description}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="validationCustom03"
                                                                        required=""
                                                                        value={row.Description}
                                                                        onChange={(e) => this.handleDescriptionChange(index, 'Description', e.target.value)}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <i
                                                                        className="fa fa-trash text-danger"
                                                                        style={{ cursor: 'pointer', fontSize: '16px' }}
                                                                        onClick={() => this.deleteDescriptionRow(index)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        )) : (
                                                            <tr><td className="text-center" colSpan={8}>No record found</td></tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-start mt-2 mb-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={() => this.addDescriptionRow()}
                                                >
                                                    + Add Row
                                                </button>
                                            </div>
                                            <div className="d-flex justify-content-end mt-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-aqua btn-sm"
                                                    onClick={() => this.saveEnquiryHotelVenue()}
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    className="btn btn-gray btn-sm mx-1"
                                                    type="button"
                                                    onClick={() => window.history.back()}
                                                >
                                                    Back
                                                </button>
                                            </div>
                                        </div>
                                    </> :
                                    <>
                                        <div className="row m-0">
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Hotel Name<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={HotelName}
                                                    onChange={(e) => this.setState({ HotelName: e.target.value, HotelNameErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{HotelNameErr}</span>}
                                            </div>
                                            <div className="col-xl-8">
                                                <label htmlFor="validationCustom03">
                                                    Hotel Address<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={HotelAddress}
                                                    onChange={(e) => this.setState({ HotelAddress: e.target.value, HotelAddressErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{HotelAddressErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Person Name<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={PersonName}
                                                    onChange={(e) => this.setState({ PersonName: e.target.value, PersonNameErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{PersonNameErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Mobile No.<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={MobileNo}
                                                    onChange={(e) => this.setState({ MobileNo: e.target.value, MobileNoErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{MobileNoErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Email<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={EmailId}
                                                    onChange={(e) => this.setState({ EmailId: e.target.value, EmailIdErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{EmailIdErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Website<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={Website}
                                                    onChange={(e) => this.setState({ Website: e.target.value, WebsiteErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{WebsiteErr}</span>}
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-end mt-2">
                                            <button
                                                type="button"
                                                className="btn btn-aqua btn-sm"
                                                onClick={() => this.saveOtherHotel()}
                                            >
                                                Save
                                            </button>
                                            <button
                                                className="btn btn-gray btn-sm mx-1"
                                                type="button"
                                                onClick={() => window.history.back()}
                                            >
                                                Back
                                            </button>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua btn-sm"
                                        onClick={(e) => this.deleteSecurityApplicationMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray btn-sm" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Footer />
            </>
        )
    }
}

export default withRouter(connect(null, { getEnquiryHotelVenueList_action, getEnquiryHotelVenueDetails_action, insertUpdateEnquiryHotelVenue_action, insertUpdateOtherHotel_action, deleteEnquiryHotelVenue_action, fill_action })(TravelAndHospitalityMasterAU));
